module.exports = __webpack_public_path__ + "img/mantenDatos.ad7e52c1.png";